import React from 'react';
import { Lock, Unlock } from 'lucide-react';

interface LockPillProps {
  locked: boolean;
  onChange: (locked: boolean) => void;
}

export default function LockPill({ locked, onChange }: LockPillProps) {
  return (
    <div className="inline-flex bg-[#F2F4F7] rounded-lg p-0.5">
      <button
        type="button"
        onClick={() => onChange(false)}
        title="Unlocked"
        aria-label="Set unlocked"
        className={`w-9 h-8 rounded-md flex items-center justify-center transition ${
          !locked ? 'bg-white shadow-sm text-ink' : 'text-ink3 hover:text-ink2'
        }`}
      >
        <Unlock className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onChange(true)}
        title="Locked"
        aria-label="Set locked"
        className={`w-9 h-8 rounded-md flex items-center justify-center transition ${
          locked ? 'bg-white shadow-sm text-ink' : 'text-ink3 hover:text-ink2'
        }`}
      >
        <Lock className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}